import React from 'react';
import {DotLottieReact} from "@lottiefiles/dotlottie-react";
import {public_url} from "../utils";
import {useSelector} from "react-redux";

function LoadingLottie({lottieFile="wave.lottie", logo}) {
    const {isDesktop} = useSelector((state) => state.app);
    return (
        <div className="relative w-20rem h-20rem"  style={{marginTop:isDesktop?'-200px':''}}>
            {lottieFile&&<DotLottieReact className="absolute w-20rem h-20rem z-0" src={public_url(lottieFile)} loop autoplay/>}
            {logo&&<img className="absolute w-5rem h-auto top-50 left-50 z-5" style={{ transform: "translate(-50%, -50%)" }} src={public_url(logo)} alt="Logo"/>}
        </div>
    );
}

export default LoadingLottie;